import styled from 'styled-components';

export const ChecklistUploaderContainer = styled.div`
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    gap: 24px;
    padding: 24px;
    width: 100%;
`;

export const SeriesSelectorContainer = styled.div`
    align-items: center;
    display: flex;
    gap: 16px;
    width: 100%;
    
    label {
        font-weight: 600;
        color: #333;
        margin-bottom: 4px;
    }
`;

export const ActionButtonsContainer = styled.div`
    display: flex;
    gap: 12px;
    width: 50%;
`;

export const JsonDisplays = styled.div`
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 24px;
    width: 100%;
    
    @media (max-width: 768px) {
        grid-template-columns: 1fr;
    }
`;

export const JsonDisplayContainer = styled.div`
    box-sizing: border-box;
    background: rgba(255, 255, 255, 0.1);
    padding: 16px;
    border-radius: 8px;
    border: 1px solid rgba(255, 255, 255, 0.2);
    width: 100%;
    
    h4 {
        margin: 0 0 16px 0;
        color: #fff;
        font-size: 16px;
        font-weight: 600;
    }
    
    pre {
        background: rgba(0, 0, 0, 0.3);
        color: #fff;
        padding: 12px;
        border-radius: 4px;
        overflow-x: auto;
        font-size: 12px;
        line-height: 1.4;
        max-height: 400px;
        overflow-y: auto;
        margin: 0;
        border: 1px solid rgba(255, 255, 255, 0.1);
    }
`;
